import { useTheme } from '@presov.sk/presov-ui-react';
import React from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

const pluginConfig: CookieConsent.CookieConsentConfig = {
  autoClearCookies: true,
  mode: 'opt-in',
  guiOptions: {
    consentModal: {
      layout: 'box',
      position: 'bottom right',
    },
    preferencesModal: {
      layout: 'box',
    },
  },
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    // marketing: {
    //   enabled: false,
    //   readOnly: false,
    // },
    // analytics: {
    //   enabled: false,
    //   readOnly: false,
    // },
  },
  //   onConsent() {
  // const analytics = param.cookie?.categories?.includes('analytics')
  //   ? 'granted'
  //   : 'denied';
  // const marketing = param.cookie?.categories?.includes('marketing')
  //   ? 'granted'
  //   : 'denied';
  // const consent = {
  //   analytics_storage: analytics,
  //   security_storage: analytics,
  //   personalization_storage: analytics,
  //   functionality_storage: analytics,
  //   ad_storage: marketing,
  //   ad_user_data: marketing,
  //   ad_personalization: marketing,
  // };
  // !!window.gtag && window.gtag('consent', 'update', consent);
  // if (marketing === 'granted') {
  //   window.dataLayer?.push(['set', 'ads_data_redaction', false]);
  // } else {
  //   window.dataLayer?.push(['set', 'ads_data_redaction', true]);
  // }
  // window.dataLayer?.push(['set', 'url_passthrough', true]);
  //   },
  language: {
    default: 'sk',
    translations: {
      sk: {
        consentModal: {
          title: 'Používame cookies!',
          description:
            'Táto stránka používa iba nevyhnutné súbory cookie potrebné pre jej správne fungovanie.',
          //   acceptAllBtn: 'Akceptovať',
          //   TODO: docasne je to 'Akceptovať' pretoze tymto sa akceptuju len docastne cookies
          acceptNecessaryBtn: 'Akceptovať',
          showPreferencesBtn: 'Nastavenie cookies',
        },
        preferencesModal: {
          title: 'Nastavenie cookies',
          //   savePreferencesBtn: 'Uložiť nastavenia',
          // TODO: docasne namiesto Akceptovať všetko
          acceptAllBtn: 'Uložiť',
          // acceptNecessaryBtn: 'Zamietnuť všetko',
          closeIconLabel: 'Zatvoriť',
          sections: [
            {
              title: 'Použitie cookies',
              description:
                'Táto stránka používa iba nevyhnutné súbory cookie potrebné pre jej správne fungovanie.',
            },
            {
              title: 'Nevyhnutné cookies',
              description:
                'Niektoré cookies sú potrebné na zabezpečenie základných funkcií. Bez týchto súborov cookie nebude web fungovať správne a sú predvolene povolené a nemožno ich deaktivovať.',
              linkedCategory: 'necessary',
            },
            // {
            //   title: 'Analytické cookies',
            //   description:
            //     'Analytické cookies nám pomáhajú zlepšovať našu webovú stránku zhromažďovaním a hlásením informácií o jej použití.',
            //   linkedCategory: 'analytics',
            // },
            // {
            //   title: 'Marketingové cookies',
            //   description:
            //     'Marketingové cookies sa používajú na sledovanie návštevníkov naprieč webovými stránkami, aby vydavatelia mohli zobrazovať relevantné a pútavé reklamy.',
            //   linkedCategory: 'marketing',
            // },
          ],
        },
      },
    },
  },
};

const Cookies: React.FC = () => {
  const theme = useTheme();

  const customStyles = React.useMemo(() => {
    return `
    .cc--mui-theme {
        color-scheme: ${theme.palette.mode === 'dark' ? 'dark' : 'light'};

        --cc-bg: ${theme.palette.background.paper};
        --cc-primary-color: ${theme.palette.text.primary};
        --cc-secondary-color: ${theme.palette.text.secondary};

        --cc-btn-primary-bg: ${theme.palette.primary.main};
        --cc-btn-primary-color: ${theme.palette.primary.contrastText};
        --cc-btn-primary-hover-bg: ${theme.palette.primary.dark};
        --cc-btn-primary-hover-color: ${theme.palette.primary.contrastText};

        --cc-btn-secondary-bg: transparent;
        --cc-btn-secondary-color: ${theme.palette.primary.main};
        --cc-btn-secondary-hover-bg: ${theme.palette.action.hover};
        --cc-btn-secondary-hover-color: ${theme.palette.primary.dark};

        --cc-cookie-category-block-bg: ${theme.palette.action.hover};
        --cc-cookie-category-block-border: ${theme.palette.divider};
        --cc-cookie-category-block-hover-bg: ${theme.palette.action.selected};
        --cc-cookie-category-block-hover-border: ${theme.palette.primary.main};
        --cc-cookie-category-expanded-block-hover-bg: ${theme.palette.action.hover};
        --cc-cookie-category-expanded-block-bg: ${theme.palette.background.default};

        --cc-overlay-bg: rgba(0, 0, 0, 0.5);

        --cc-toggle-readonly-bg: ${theme.palette.action.disabled};
        --cc-toggle-on-knob-bg: ${theme.palette.background.paper};
        --cc-toggle-off-bg: ${theme.palette.action.disabled};
        --cc-toggle-readonly-knob-bg: ${theme.palette.background.paper};

        --cc-separator-border-color: ${theme.palette.divider};

        --cc-footer-border-color: ${theme.palette.divider};
        --cc-footer-bg: ${theme.palette.background.default};

        --cc-btn-border-radius: ${theme.shape.borderRadius}px;
        --cc-modal-border-radius: ${theme.shape.borderRadius}px;
        --cc-pm-toggle-border-radius: ${theme.shape.borderRadius}px;
    }

    .cc--mui-theme #cc-main .cm__body {
        border: ${theme.typography.pxToRem(1)} solid ${theme.palette.divider};
    }

    .cc--mui-theme #cc-main .toggle__icon:after {
        border-radius: ${theme.shape.borderRadius}px;
    }

    .cc--mui-theme #cc-main .cm__btn--close {
        border-radius: ${theme.shape.borderRadius}px;
        color: #000000 !important;
        background-color: transparent !important;
    }

    .cc--mui-theme #cc-main .pm__close-btn svg {
        stroke: ${theme.palette.text.primary};
    }

    .cc--mui-theme #cc-main .pm__section-arrow svg {
        stroke: ${theme.palette.text.primary};
    }

    .cc--mui-theme #cc-main .cm__btn--close:hover {
        color: #333333 !important;
        background-color: rgba(0, 0, 0, 0.04) !important;
    }

    .cc--mui-theme #cc-main .cm__btn {
        font-family: ${theme.typography.button.fontFamily};
        font-weight: ${theme.typography.button.fontWeight};
        font-size: ${theme.typography.button.fontSize};
        letter-spacing: ${theme.typography.button.letterSpacing};
        text-transform: ${theme.typography.button.textTransform};
        min-width: 64px;
        padding: 6px 16px;
        border-radius: ${theme.shape.borderRadius}px;
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    .cc--mui-theme #cc-main .cm__btn:hover {
        box-shadow: ${theme.shadows[2]};
    }

    .cc--mui-theme #cc-main .cm__btn--secondary {
        border: 1px solid ${theme.palette.primary.main};
    }

    .cc--mui-theme #cc-main .cm__btn--secondary:hover {
        border-color: ${theme.palette.primary.dark};
    }

    .cc--mui-theme #cc-main .pm__footer .pm__btn-group button[data-role="necessary"] {
        background-color: transparent;
        color: ${theme.palette.primary.main};
        border: ${theme.typography.pxToRem(1)} solid ${theme.palette.primary.main};
    }

    .cc--mui-theme #cc-main .pm__footer .pm__btn-group button[data-role="necessary"]:hover {
        text-decoration: underline;
    }

    .cc--mui-theme #cc-main .cm__title {
        font-family: ${theme.typography.h6.fontFamily};
        font-size: ${theme.typography.h6.fontSize};
        font-weight: ${theme.typography.h6.fontWeight};
        line-height: ${theme.typography.h6.lineHeight};
        color: ${theme.palette.text.primary};
    }

    .cc--mui-theme #cc-main .cm__desc,
    .cc--mui-theme #cc-main .pm__desc {
        font-family: ${theme.typography.body1.fontFamily};
        font-size: ${theme.typography.body1.fontSize};
        font-weight: ${theme.typography.body1.fontWeight};
        line-height: ${theme.typography.body1.lineHeight};
        color: ${theme.palette.text.secondary};
    }

    .cc--mui-theme #cc-main .pm__section-title {
        font-family: ${theme.typography.h6.fontFamily};
        font-size: ${theme.typography.h6.fontSize};
        font-weight: ${theme.typography.h6.fontWeight};
        color: ${theme.palette.text.primary};
    }

    .cc--mui-theme #cc-main .cc-link {
        color: ${theme.palette.primary.main};
        text-decoration: none;
    }

    .cc--mui-theme #cc-main .cc-link:hover {
        color: ${theme.palette.primary.dark};
        text-decoration: underline;
    }

    .cc--mui-theme #cc-main .cm {
        box-shadow: ${theme.shadows[8]};
    }

    .cc--mui-theme #cc-main .pm {
        box-shadow: ${theme.shadows[16]};
    }

    @media print {
        .cc--mui-theme #cc-main .cm__body {
            display: none !important;
        }
    }

    /* Od md je vpravo panel so zoznamom a banner na 'bottom right' by sadol naň,
       kde na bielych kartách zanikne. Posúvame ho teda o šírku panela doľava,
       nad mapu. Šírku nedosadzujeme číslom - panel je flexibilný a na širokých
       obrazovkách vyrastie nad svoje minimum, takže by medzera na každej šírke
       vyšla inak. Meria ju HomePage do --feed-panel-width; bez nej (ostatné
       stránky) je odsadenie nulové a banner zostáva v pravom dolnom rohu.
       Medzeru k panelu drží --cc-modal-margin, teda tá istá premenná, ktorou
       plugin odsadzuje banner od ostatných hrán - padding je tým dokola rovnaký
       a nerozíde sa ani keď plugin margin zmenší na malých obrazovkách. */
    ${theme.breakpoints.up('md')} {
        .cc--mui-theme #cc-main .cm--right {
            right: calc(var(--feed-panel-width, 0px) + var(--cc-modal-margin));
        }
    }
`;
  }, [theme]);

  React.useEffect(() => {
    // Inject custom styles
    const styleElement = document.createElement('style');
    styleElement.textContent = customStyles;
    document.head.appendChild(styleElement);

    // Apply MUI theme class to html element
    document.documentElement.classList.add('cc--mui-theme');

    CookieConsent.run(pluginConfig);

    return () => {
      document.head.removeChild(styleElement);
      document.documentElement.classList.remove('cc--mui-theme');
    };
  }, [customStyles]);

  return null;
};

export default Cookies;
